export type TipoSolicitacao =
  | 'INCLUSAO_PARTE'
  | 'ALTERACAO_PARTE'
  | 'EXCLUSAO_PARTE'
  | 'ALTERACAO_DADOS'
  | 'ALTERACAO_BREVE_RELATO'
  | 'ALTERACAO_PEDIDO'
  | 'IMPUGNACAO_ARBITRO'
  | 'CANCELAMENTO'
  | 'ADICIONAR_ADVOGADO'
  | 'HABILITACAO_ADVOGADO';

export type StatusSolicitacao = 'SOLICITADA' | 'APROVADA' | 'REJEITADA' | 'CANCELADA';

export type FiltroSolicitacoes = 'PENDENTES' | 'AGUARDANDO_ARBITRO' | 'RESOLVIDAS' | 'TODAS';

export type PapelSolicitante =
  | 'REQUERENTE'
  | 'REQUERIDO'
  | 'ADVOGADO_REQUERENTE'
  | 'ADVOGADO_REQUERIDO'
  | 'SECRETARIA'
  | 'DESCONHECIDO';

// TODO(#774): promover para src/types/ — shape idêntico a AlteracaoExibida de arbitral-detalhes
export interface AlteracaoSolicitada {
  campo: string;
  de: string | null;
  para: string;
}

export interface AcoesSolicitacao {
  aceitar: boolean;
  recusar: boolean;
  concluso: boolean;
  liberarAdvogado: boolean;
}

export interface ConclusoSolicitacao {
  em: string;
  arbitroNome: string | null;
  prazoLimite: string | null;
  atrasado: boolean;
}

export interface RespostaArbitroSolicitacao {
  em: string;
  decisao: 'DEFERIDO' | 'INDEFERIDO' | null;
  parecer: string | null;
}

export interface DecisaoSecretaria {
  em: string;
  por: string | null;
  motivoRecusa: string | null;
}

export interface AnexoSolicitacao {
  id: string;
  nome: string;
  tamanhoBytes: number;
  downloadUrl: string;
}

export interface SolicitacaoSecretaria {
  id: string;
  tipo: TipoSolicitacao;
  tipoLabel: string;
  status: StatusSolicitacao;
  statusLabel: string;
  solicitante: { nome: string; papel: PapelSolicitante; papelLabel: string; oab: string | null };
  criadoEm: string;
  resumo: string;
  anexo: AnexoSolicitacao | null;
  justificativaParte: string | null;
  alteracoes: AlteracaoSolicitada[];
  decisao: DecisaoSecretaria | null;
  concluso: ConclusoSolicitacao | null;
  respostaArbitro: RespostaArbitroSolicitacao | null;
  conclusoEncerradoPelaSentenca: boolean;
  acoes: AcoesSolicitacao;
  motivoBloqueio: string | null;
}

export type ModoDecisaoSolicitacao = 'ACEITAR' | 'RECUSAR';

export interface DecidirSolicitacaoInput {
  processoId: string;
  solicitacaoId: string;
  modo: ModoDecisaoSolicitacao;
  justificativa: string;
  modeloAndamentoId?: string;
  clientRequestId: string;
  anexos: File[];
}

export interface DecidirSolicitacaoResultado {
  solicitacaoId: string;
  status: 'APROVADA' | 'REJEITADA';
  andamentoId: string;
  pendenciasCriadas: number;
  /**
   * Pendência de aviso que a decisão fechou junto — a que a solicitação abriu para a Secretaria
   * ao nascer. `null` quando não havia nenhuma viva (já resolvida à mão, ou solicitação antiga
   * sem andamento gravado).
   */
  pendenciaResolvidaId: string | null;
  aplicou: boolean;
  alteracoesAplicadas: AlteracaoSolicitada[];
}

export interface ConcluirSolicitacaoInput {
  processoId: string;
  solicitacaoId: string;
  mensagem: string;
  modeloAndamentoId?: string;
  clientRequestId: string;
  anexos: File[];
}

export interface ConcluirSolicitacaoResultado {
  pendenciaArbitroId: string;
  arbitroProcessoId: string;
  dataVencimento: string;
}

export type ContagemSolicitacoes = Record<FiltroSolicitacoes, number>;

export interface SolicitacoesSecretariaResposta {
  itens: SolicitacaoSecretaria[];
  contagem: ContagemSolicitacoes;
  arbitragemInstaurada: boolean;
  arbitroNome: string | null;
}

export const FILTROS_SOLICITACOES: Array<{ value: FiltroSolicitacoes; label: string }> = [
  { value: 'PENDENTES', label: 'Pendentes' },
  { value: 'AGUARDANDO_ARBITRO', label: 'Aguardando árbitro' },
  { value: 'RESOLVIDAS', label: 'Resolvidas' },
  { value: 'TODAS', label: 'Todas' },
];

export const EMPTY_STATE_POR_FILTRO: Record<
  FiltroSolicitacoes,
  { titulo: string; descricao: string }
> = {
  PENDENTES: {
    titulo: 'Nada para decidir agora',
    descricao: 'Nenhuma solicitação aguardando decisão da Secretaria neste processo.',
  },
  AGUARDANDO_ARBITRO: {
    titulo: 'Nada com o árbitro',
    descricao: 'Nenhuma solicitação foi conclusa ao árbitro e está aguardando retorno.',
  },
  RESOLVIDAS: {
    titulo: 'Nenhuma solicitação resolvida',
    descricao: 'Ainda não há solicitação aceita, recusada ou cancelada pela parte.',
  },
  TODAS: {
    titulo: 'Nenhuma solicitação',
    descricao: 'As partes ainda não pediram nenhuma alteração neste processo.',
  },
};
